import React from "react";

const metrics = [
  { value: "200+", label: "businesses trust us" },
  { value: "5000+", label: "customers served" },
  { value: "98%", label: "retention rate" },
  { value: "24/7", label: "support available" },
];

const SocialProofMetrics = () => {
  return (
    <section className="w-full bg-white py-12 md:py-16 px-4 sm:px-6 md:px-12 lg:px-16 border-t border-gray-100">
      <div className="max-w-[1260px] mx-auto">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
          {metrics.map((metric) => (
            <div key={metric.label} className="flex flex-col items-center text-center gap-1 sm:gap-2">
              <span className="text-3xl sm:text-4xl md:text-5xl font-bold font-lexend text-[#6E3FC6]">
                {metric.value}
              </span>
              <span className="text-xs sm:text-sm md:text-base font-poppins text-gray-500">
                {metric.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SocialProofMetrics;
